module.exports = __webpack_public_path__ + "media/images/bg/patterns/activities/3-b076be1d9d32e7d10d3262c2960cd5db.svg";